import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Oval } from "react-loader-spinner";
import { API_URL } from "../../shared/constant";
import axios from "axios";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import Loader from "../../shared/loader";
const Party = () => {
  const [partyData, setPartyData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [loading, setLoading] = useState(true);
  const [searchParam] = useState([
    "gst_no",
    "name",
    "city",
    "state_name",
    "party_type",
  ]);

  const getParty = () => {
    axios.post(API_URL.PARTY_LIST, {}).then(
      (res) => {
        if (res.data.status === 1) {
          setPartyData(res.data.data);
        }
        setLoading(false);
      },
      (error) => {
        setLoading(false);
        toast.error("Something went wrong..", {
          autoClose: 3000,
          position: "top-right",
        });
      }
    );
  };
  const rejectParty = (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: 'Are you sure you want to reject this party "' + row.name + '"?',
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Reject it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios
          .post(API_URL.PARTY_UPDATE_STATUS, {
            id: row.id,
            status: 0,
          })
          .then((res) => {
            if (res.data.status === 0) {
              toast.success(row.name + " Reject successfully", {
                autoClose: 3000,
                position: "top-right",
              });

              getParty();
            }
            setLoading(false);
          });
      }
    });
  };

  const approvParty = (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: 'Are you sure you want to approve this party "' + row.name + '"?',
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Approve it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios
          .post(API_URL.PARTY_UPDATE_STATUS, {
            id: row.id,
            status: 1,
          })
          .then((res) => {
            if (res.data.status === 1) {
              toast.success(row.name + " approved successfully", {
                autoClose: 3000,
                position: "top-right",
              });

              getParty();
            }
            setLoading(false);
          });
      }
    });
  };

  const deleteParty = (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this - " + row.name,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios.post(API_URL.PARTY_DELETE, { id: row.id }).then(
          (res) => {
            if (res.data.status === 1) {
              let newData = partyData.filter((r) => r.id != row.id);
              setPartyData(newData);
            }
            toast.success(row.name + " Delete Successfully", {
              autoClose: 3000,
              position: "top-right",
            });
            setLoading(false);
          },
          (error) => {
            setLoading(false);
            toast.error("Something went wrong..", {
              autoClose: 3000,
              position: "top-right",
            });
          }
        );
      }
    });
  };

  const searchParty = (value) => {
    setSearchValue(value);
  };

  const search = (items) => {
    return items.filter((item) => {
      return searchParam.some((newItem) => {
        return (
          item[newItem] &&
          item[newItem]
            .toString()
            .toLowerCase()
            .indexOf(searchValue.toLowerCase()) > -1
        );
      });
    });
  };

  useEffect(() => {
    getParty();
  }, []);
  return (
    <>
      <div className="page-header">
        <div className="d-flex align-items-center content-page-header">
          <div className="d-flex align-items-center">
            <h5 className="me-1">Party</h5>
            <small className="me-2">({partyData.length})</small>
            <div className="form-group mb-0">
              <input
                type="text"
                value={searchValue}
                onChange={(e) => searchParty(e.target.value)}
                className="form-control-sm header-search-bar-input"
                style={{ border: "1px solid lightgray" }}
                placeholder="Search by text..."
              />
            </div>
          </div>
          <div className="list-btn">
            <ul className="filter-list">
              <li>
                <Link
                  to={"/admin/party/add"}
                  className="btn btn-primary btn-sm"
                >
                  <i className="fa fa-plus-circle me-2" aria-hidden="true"></i>
                  Party
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12">
          <div className="card-table">
            <div className="card-body">
              {loading && <Loader></Loader>}
              {!loading && (
                <div>
                  <div className="table-responsive">
                    <table className="table table-center table-hover datatable">
                      <thead className="thead-light">
                        <tr>
                          <th style={{ width: "5%" }}>#</th>
                          <th style={{ width: "20%" }}>Name</th>
                          <th style={{ width: "25%" }}>Email</th>
                          <th style={{ width: "20%" }}>Location</th>
                          <th style={{ width: "20%" }}>GST No.</th>
                          <th style={{ width: "10%" }}></th>
                        </tr>
                      </thead>
                      <tbody>
                        {search(partyData).map((row, key) => {
                          return (
                            <tr key={key}>
                              <td>{key + 1}</td>
                              <td>
                                {row.status === 1 && (
                                  <i
                                    className="fa fa-check-circle me-2 text-success"
                                    aria-hidden="true"
                                  ></i>
                                )}
                                {row.name}
                              </td>
                              <td>{row.email}</td>
                              <td>
                                {row.city_name && (
                                  <span>{row.city_name}, </span>
                                )}
                                {row.state_name && (
                                  <span>{row.state_name}, </span>
                                )}
                                {row.country_name && (
                                  <span>{row.country_name}</span>
                                )}
                              </td>
                              <td>{row.gst_no || "-"}</td>
                              <td className="d-flex justify-content-end gap-3">
                                <Link to={"/admin/party/edit/" + row.id}>
                                  <i className="fa fa-edit"></i>
                                </Link>
                                <i
                                  onClick={() => deleteParty(row)}
                                  className="fa fa-trash-alt"
                                ></i>
                                {row.status === 0 && (
                                  <i
                                    className="fa fa-check"
                                    onClick={() => approvParty(row)}
                                  ></i>
                                )}
                                {row.status === 1 && (
                                  <i
                                    className="fa fa-times"
                                    onClick={() => rejectParty(row)}
                                  ></i>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Party;
